<div class="game-ad-beta-container">
  <div nz-row [nzGutter]="[16, 16]">
    <!-- Text Section for All Screens -->
    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="10" class="section-text">
      <div class="text-container">
        <h2 class="heading">
          Unbeatable Deals,<br>Unforgettable Games –<br>Don't Miss Out!
        </h2>
        <h1 class="discount">
          -%60
        </h1>
      </div>
    </div>

    <!-- Cards Section (Stack on Mobile, Row on Desktop) -->
    <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="16" [nzLg]="14">
      <div nz-row [nzGutter]="[16, 16]">
        <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="8" *ngFor="let item of data; let i = index">
          <app-game-card-gamma *ngIf="item" [data]="item"></app-game-card-gamma>
        </div>
      </div>
    </div>
  </div>
</div>
